import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import { PetitionPageVideos, type PetitionPageVideosQuery, type PetitionPageVideosQueryVariables } from './api.graphql';

export type SupporterVoicesVideos = {
	enabled: boolean;
	videos: PetitionPageVideosQuery['petitionVideosConnection']['nodes'];
	totalCount: number;
};

export const getSupporterVoicesVideos = async (
	utilityContext: UtilityContext,
	slugOrId: string,
	disableDisplay: boolean,
): Promise<SupporterVoicesVideos> => {
	/**
	 * Moderation staff can disable display of videos using petition metadata, in which case we
	 * should not fetch them at all.
	 */
	if (disableDisplay) {
		return {
			enabled: false,
			videos: [],
			totalCount: 0,
		};
	}

	const { data } = await utilityContext.gql.fetch<PetitionPageVideosQuery, PetitionPageVideosQueryVariables>({
		query: PetitionPageVideos,
		variables: {
			petitionSlugOrId: slugOrId,
			first: 10,
			sortBy: 'SCORE',
		},
		rejectOnError: false,
		batched: true,
	});

	return {
		enabled: true,
		videos: data?.petitionVideosConnection.nodes ?? [],
		totalCount: data?.petitionVideosConnection.totalCount ?? 0,
	};
};
